import { render } from "./StoreItems.vue?vue&type=template&id=51a43f7a&scoped=true"
import script from "./StoreItems.vue?vue&type=script&lang=js"
export * from "./StoreItems.vue?vue&type=script&lang=js"

import "./StoreItems.vue?vue&type=style&index=0&id=51a43f7a&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a43f7a"]])

export default __exports__